import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';
import ContainerlessTableViewApp from '../../TableView/startup/ContainerlessTableViewApp';
import StatusBadge from '../../../shared/StatusBadge';
import InvoiceMemberCell from './cells/InvoiceMemberCell';
import InvoiceAmountCell from './cells/InvoiceAmountCell';

const COLUMNS_WITH_MEMBER = [
  { data: 'created_at', label: 'Date' },
  { data: 'member', label: 'Paid by' },
  { data: 'status', label: 'Status' },
  { data: 'amount_paid_cents', label: 'Amount' },
];

const COLUMNS_WITHOUT_MEMBER = COLUMNS_WITH_MEMBER.filter((c) => c.data !== 'member');

export default function MembershipInvoicesDatatable({
  datatablePath,
  membershipId = null,
  showMemberColumn = true,
}) {
  const columns = useMemo(
    () => (showMemberColumn ? COLUMNS_WITH_MEMBER : COLUMNS_WITHOUT_MEMBER),
    [showMemberColumn]
  );

  const dataSource = useMemo(() => {
    if (!membershipId) return datatablePath;
    const separator = datatablePath.includes('?') ? '&' : '?';
    return `${datatablePath}${separator}membership_id=${encodeURIComponent(membershipId)}`;
  }, [datatablePath, membershipId]);

  const rowCallback = useMemo(
    () => (row, rowData) => {
      if (showMemberColumn) {
        const memberEl = row.getElementsByClassName('member-cell')[0];
        if (memberEl) {
          ReactDOM.render(
            <InvoiceMemberCell
              name={rowData.fan_name}
              email={rowData.fan_email}
              path={rowData.membership_show_path}
            />,
            memberEl
          );
        }
      }

      const statusEl = row.getElementsByClassName('status-cell')[0];
      if (statusEl) {
        ReactDOM.render(<StatusBadge status={rowData.status_value} />, statusEl);
      }

      const amountEl = row.getElementsByClassName('amount-cell')[0];
      if (amountEl) {
        ReactDOM.render(
          <InvoiceAmountCell amountCents={rowData.amount_paid_cents_value} />,
          amountEl
        );
      }
    },
    [showMemberColumn]
  );

  return (
    <div>
      <ContainerlessTableViewApp
        key={`invoices-${membershipId || 'all'}`}
        dataSource={dataSource}
        columns={columns}
        order={[[0, 'desc']]}
        rowCallback={rowCallback}
      />
    </div>
  );
}
